import { render, staticRenderFns } from "./reditrct.vue?vue&type=template&id=3e7da4a9&"
import script from "./reditrct.vue?vue&type=script&lang=js&"
export * from "./reditrct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports